var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOkay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_602_666)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12Z",
    fill: "#29CC39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8363 8.36358C17.1878 8.71505 17.1878 9.2849 16.8363 9.63637L10.8363 15.6364C10.4848 15.9878 9.91498 15.9878 9.56351 15.6364L7.16351 13.2364C6.81203 12.8849 6.81203 12.3151 7.16351 11.9636C7.51498 11.6121 8.08483 11.6121 8.4363 11.9636L10.1999 13.7272L12.8817 11.0454L15.5635 8.36358C15.915 8.01211 16.4848 8.01211 16.8363 8.36358Z",
    fill: "#29CC39"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_602_666"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOkay);
export default __webpack_public_path__ + "static/media/Okay.905c096433803139b6213f2c13bbcd9e.svg";
export { ForwardRef as ReactComponent };